import { gql } from "@apollo/client";

export const GET_COURSE_SUGGESTIONS = gql`
  query getCourseSuggestions($isResolved: Boolean = false) {
    courseSuggestions(isResolved: $isResolved) {
      count
      courseSuggestions {
        title
        suggestedBy {
          username
        }
        isResolved
        createdAt
        university
        updatedAt
        isAccepted
        resolvedBy {
          username
        }
        _id
        resolvingComment
      }
    }
  }
`;

export const RESOLVE_COURSE_SUGGESTION = gql`
  mutation resolveCourseSuggestion(
    $_id: String!
    $isAccepted: Boolean!
    $resolvingComment: String
  ) {
    resolveCourseSuggestion(
      _id: $_id
      isAccepted: $isAccepted
      resolvingComment: $resolvingComment
    )
  }
`;
